import en from './en_seo';
import tr from './tr_seo';

export default {
    en,
    tr
}